import { ApiResponseDTO } from "@zenith/services/utils/ApiResponseDTO";

export interface BannerContent {
  id: number;
  documentId: string;
  Title: string;
  Description: string;
  Active: boolean;
  Campaign: string;
  showText: boolean;
  ctaLink?: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  Image: {
    id: number;
    documentId: string;
    name: string;
    alternativeText: string | null;
    caption: string | null;
    width: number;
    height: number;
    formats: {
      small: ImageFormat;
      medium: ImageFormat;
      thumbnail: ImageFormat;
    };
    hash: string;
    ext: string;
    mime: string;
    size: number;
    url: string;
    previewUrl: string | null;
    provider: string;
    provider_metadata: any;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  }[];
}

interface ImageFormat {
  ext: string;
  url: string;
  hash: string;
  mime: string;
  name: string;
  path: string | null;
  size: number;
  width: number;
  height: number;
  sizeInBytes: number;
}

export class BannerService {
  private static readonly BASE_URL =
    import.meta.env.VITE_STRAPI_BASE_URL || "http://localhost:1337";

  public static async getMarketingBanners(): Promise<
    ApiResponseDTO<BannerContent[]>
  > {
    try {
      const response = await fetch(
        `${this.BASE_URL}/api/dashboard-images?populate=*`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      return {
        data: data.data,
        success: true,
      };
    } catch (error) {
      console.error("Error fetching marketing banners:", error);
      return {
        success: false,
        message: "Failed to fetch marketing banners",
      };
    }
  }
}
